export default __webpack_public_path__ + "static/media/ico_dashboard.3b98fd15.svg";